/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
const useReportListFilter = ({ handleReportListFilter }: any) => {
  React.useEffect(() => {
    handleReportListFilter();
  }, []);
};

export default useReportListFilter;
